const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconTranslation(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none"
    },
    d: "M0 0h18v18H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 907",
    d: "M1516.179 644.5a6 6 0 0 0-9.512-6.257l1.674.118-.375-.545",
    transform: "translate(-1501.379 -633.957)",
    style: {
      stroke: "#1f62b9",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 908",
    d: "M1504.236 642a6 6 0 0 0 9.475 6.391l-1.674-.118.375.545",
    transform: "translate(-1500.998 -634.678)",
    style: {
      stroke: "#1f62b9",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 909",
    d: "M1513.093 605.634h-.835l-2.2 6.375h1.027l.545-1.7h2.073l.586 1.7h1.02zm-.43 1.553.71 2.139h-1.415z",
    transform: "translate(-1503.307 -599.633)",
    style: {
      fill: "#1f62b9"
    }
  }));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTranslation);
export default __webpack_public_path__ + "static/media/icon-translation.008744590a81bbdc5c1dd2ffb17e36be.svg";
export { ForwardRef as ReactComponent };